"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMuiMenuOverrides = function (_a) {
    var palette = _a.palette, spacing = _a.spacing;
    return ({
        paper: {
            transform: "translateY(5px)",
            border: "none",
            backgroundColor: palette.background.overlays,
            boxShadow: "0px 5px 10px rgba(0, 0, 0, 0.35);",
        },
        list: {
            margin: spacing(1, 0),
        },
    });
};
//# sourceMappingURL=MuiMenu.js.map